<template>
    <button
        type="button"
        class="cursor-pointer focus-visible:outline-2 focus-visible:outline-offset-1 focus-visible:outline-blue-500"
        :aria-label="null === props.value ? `Copy ${props.label}` : `Copy ${props.label}: ${props.value}`"
    >
        <slot>{{ props.value }}</slot>
    </button>
</template>

<script setup lang="ts">
// Callers copy on click, often the raw value rather than the formatted one named here.
const props = withDefaults(
    defineProps<{
        label: string;
        value?: string | number | null;
    }>(),
    { value: null }
);
</script>
